import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useParticipantStyles() {
  const { spacing } = useTheme();
  const cardStyles = useMemo(
    () => mergeStyleSets({
      root: {
        overflow: `hidden`,
        margin: spacing.s2,
        padding: spacing.m
      },
      header: {
        fontSize: `1.1em`
      },
      content: {
        overflowY: `auto`
      }
    }),
    [spacing]
  );

  return {
    cardStyles
  };
}
